export const ROUDisclosure = {
    openingROU: "Opening balance at period start",
    additionsDuringYearROU: "Add: Additions during the period",
    modificationAdjustmentROU: "Add/Less: Modifications during the period",
    amortization: "Less: Amortization during the period",
    closingROU: "Closing balance at period end",
}
export const LLDisclosure = {
    openingLL: "Opening balance at period start",
    additionsDuringYearLL: "Add: Additions during the period",
    modificationAdjustmentLL: "Add/Less: Modifications during the period",
    interest: "Add: Interest during the period",
    payment: "Less: Payment during the period",
    closingLL: "Closing balance at period end",
}
export const DisclosureMaturity = {
    lessThanOneYear: "Less than one year",
    betweenOneAndFiveYears: "Between one and five years",
    afterFiveYears: "After five years",
}